import Counter from "../Components/Counter"
import MilIllustrationSlider from "../Components/MilIllustrationSlider";

export default function Industrial() {
    const industrialPhotos = [
        'assets/images/offer/industrial/1.png',
        'assets/images/offer/industrial/2.png',
        'assets/images/offer/industrial/3.png',
        'assets/images/offer/industrial/4.png',
    ];

    return(
      <div className="mil-wrapper">
        <div id="content">

          <section class="mil-banner mil-banner-sm">
            <img src="assets/images/background/background-6.png" class="mil-bg-img mil-scale" data-value-1=".4" data-value-2="1.4" alt="Tło budynki mieszkalne." style={{ objectPosition: "top" }} />
              <div class="container">
                <div class="mil-background-grid mil-top-space"></div>
                  <div class="mil-banner-content mil-center">
                    <div class="mil-mb-90">
                      <h1 class="mil-light mil-upper mil-mb-30">BUDOWNICTWO<br/>USŁUGOWO-<br/>PRZEMYSŁOWE</h1>
                    </div>
                  </div>
              </div>
            </section>

          <section>
                <div class="container mil-p-120-60">
                    <div class="mil-background-grid mil-softened"></div>
                    <div class="row justify-content-between">
                        <div class="col-lg-7">

                            <h2 class="mil-upper mil-up mil-mb-60">Funkcjonalne obiekty<br/>dla Twojego biznesu</h2>
                            <p class="mil-up mil-mb-30">Realizujemy kompleksowe projekty budowlane dla sektora usługowego i przemysłowego. Budujemy hale produkcyjne, magazyny, obiekty handlowe i biurowe, dostosowane do indywidualnych potrzeb każdego biznesu. Nasze doświadczenie pozwala nam na efektywne zarządzanie inwestycją i dostarczanie funkcjonalnych, trwałych i nowoczesnych obiektów. Realizujemy projekty na terenie całego kraju, ze szczególnym uwzględnieniem województwa mazowieckiego w zakresie budownictwa przemysłowego.</p>
                            <div class="mil-divider-lg mil-up mil-mb-60"></div>
                            <h3 class="mil-upper mil-up mil-mb-60">Proces budowy obiektu przemysłowego</h3>
                            
                            <div class="col-lg-12">
                              <div class="d-flex align-items-center mil-mb-15">
                                <div class="flex-shrink-0">
                                  <img src="assets/images/icons/01.png" alt="01 numer" style={{ width:"70px"}} />
                                </div>
                                <div class="flex-grow-1 ms-3" >
                                  <h5>Analiza potrzeb i koncepcja</h5>
                                  <p>Rozpoczynamy od szczegółowej analizy wymagań technologicznych i logistycznych Twojego biznesu, aby zaproponować optymalną koncepcję funkcjonalną i przestrzenną obiektu.</p>
                                 </div>
                              </div>
                              <div class="d-flex align-items-center mil-mb-15" >
                                <div class="flex-shrink-0">
                                  <img src="assets/images/icons/02.png" alt="02 numer" style={{ width:"70px"}} />
                                </div>
                                <div class="flex-grow-1 ms-3" >
                                  <h5>Projektowanie i formalności</h5>
                                  <p>Współpracujemy z biurami projektowymi w celu stworzenia pełnej dokumentacji technicznej. Bierzemy na siebie ciężar uzyskania niezbędnych pozwoleń i decyzji administracyjnych.</p> 
                                </div>
                              </div>
                              <div class="d-flex align-items-center mil-mb-15">
                                <div class="flex-shrink-0">
                                  <img src="assets/images/icons/03.png" alt="03 numer" style={{ width:"70px"}} />
                                </div>
                                <div class="flex-grow-1 ms-3">
                                  <h5>Realizacja i montaż konstrukcji</h5>
                                  <p>Przechodzimy do prac budowlanych – od robót ziemnych, przez fundamenty, aż po montaż głównej konstrukcji nośnej hali, ścian osłonowych i dachu.</p>
                                  </div>
                              </div>
                              <div class="d-flex align-items-center mil-mb-15">
                                <div class="flex-shrink-0">
                                  <img src="assets/images/icons/04.png" alt="04 numer" style={{ width:"70px"}} />
                                </div>
                                <div class="flex-grow-1 ms-3">
                                  <h5>Instalacje, wykończenie i odbiór</h5>
                                  <p>Wykonujemy specjalistyczne instalacje, posadzki przemysłowe oraz prace wykończeniowe w częściach biurowych i socjalnych, a następnie przygotowujemy obiekt do odbioru i uruchomienia.</p>
                                </div>
                              </div>
                              
                            </div>


                        </div>
                        <div class="col-lg-5">

                            <div class="mil-sidebar-frame mil-mb-60">
                                <h2 class="mil-upper mil-up mil-mb-60">Inne usługi</h2>
                                <p class="mil-dark mil-mb-5">Budownictwo wielorodzinne</p>
                                <p class="mil-dark mil-mb-5">Budownictwo usługowo - przemysłowe</p>
                                <p class="mil-dark mil-mb-30">Realizacje</p>
                                
                                <div class="mil-divider-lg mil-up mil-mb-30"></div>

                                <div class="row sc-p-txt">
                                    <div class="col-6">
                                        <div class="mil-counter-frame mil-up mil-mb-30">
                                            <h5 class="mil-mb-5 mil-accent">
                                               <Counter target={1000} />+
                                            </h5>
                                            <p class="mil-dark">Wykonanych zleceń</p>
                                        </div>
                                    </div>
                                    <div class="col-6">

                                        <div class="mil-counter-frame mil-up mil-mb-30">
                                            <h5 class="mil-mb-5 mil-accent">
                                               <Counter target={30} />+
                                            </h5>
                                            <p class="mil-dark">Doświadczonych pracowników</p>
                                        </div>

                                    </div>
                                    <div class="col-6">

                                        <div class="mil-counter-frame mil-up mil-mb-30">
                                             <h5 class="mil-mb-5 mil-accent">
                                               <Counter target={10} />+
                                            </h5>
                                            <p class="mil-dark">Lat doświadczenia</p>
                                        </div>

                                    </div>
                                    <div class="col-6">

                                        <div class="mil-counter-frame mil-up mil-mb-30">
                                            <h5 class="mil-mb-5 mil-accent">
                                               <Counter target={50000} />+
                                            </h5>
                                            <p class="mil-dark">Godzin <br />pracy</p>
                                        </div>

                                    </div>
                                </div>

                                <div class="mil-divider-lg mil-up mil-mb-30"></div>

                                <h6 class="mil-upper mil-up mil-mb-30">Kontakt</h6>
                                <p class="mil-dark mil-mb-30">Zapraszamy do kontaktu:<br />Pon - Piąt: 8:00 - 17:00</p>
                                <p class="mil-dark mil-mb-5">Waryńskiego 33/2, 87-100 Toruń</p>
                                <p class="mil-dark mil-mb-5">+48 534 727 286</p>
                                <p class="mil-dark mil-mb-5">biuro@holtyn-bud.pl</p>
                            </div>
                        </div>
                    </div>
                </div>
          </section>

          <section>
                <div class="container mil-p-120-90">
                    <div class="mil-background-grid mil-softened"></div>

                    <div class="mil-center mil-mb-90">
                        <h2 class="mil-upper mil-up">ZAKRES NASZYCH PRAC</h2>
                    </div>

                    <div class="row">
                        <div class="col-lg-4 mil-up">

                            <div  class="mil-service-card mil-mb-30">
                                <div class="mil-center">
                                    <h4 class="mil-upper mil-mb-20">Budowa hal <br/>przemysłowych</h4>
                                    <div class="mil-divider-sm mil-mb-20"></div>
                                    <p class="mil-service-text">Konstrukcje stalowe i żelbetowe, hale produkcyjne i magazynowe.</p> 
                                </div>
                            </div>

                        </div>
                        <div class="col-lg-4 mil-up">
                            <div class="mil-service-card mil-mb-30">
                                <div class="mil-center">
                                    <h4 class="mil-upper mil-mb-20">Obiekty usługowe<br/>i handlowe</h4>
                                    <div class="mil-divider-sm mil-mb-20"></div>
                                    <p class="mil-service-text">Pawilony, salony sprzedaży, warsztaty i inne obiekty komercyjne.</p>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 mil-up">
                            <div class="mil-service-card mil-mb-30">
                                <div class="mil-center">
                                    <h4 class="mil-upper mil-mb-20">Generalne <br/>wykonawstwo</h4>
                                    <div class="mil-divider-sm mil-mb-20"></div>
                                    <p class="mil-service-text">Pełna obsługa inwestycji od projektu po odbiór końcowy.</p>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 mil-up">
                            <div class="mil-service-card mil-mb-30">
                                <div class="mil-center">
                                    <h4 class="mil-upper mil-mb-20">Fundamenty <br/>specjalistyczne</h4>
                                    <div class="mil-divider-sm mil-mb-20"></div>
                                    <p class="mil-service-text">Posadowienie maszyn i ciężkich konstrukcji przemysłowych.</p>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 mil-up">
                            <div class="mil-service-card mil-mb-30">
                                <div class="mil-center">
                                    <h4 class="mil-upper mil-mb-20">Posadzki<br/>przemysłowe</h4>
                                    <div class="mil-divider-sm mil-mb-20"></div>
                                    <p class="mil-service-text">Wytrzymałe i odporne na obciążenia posadzki betonowe.</p>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 mil-up">
                            <div class="mil-service-card mil-mb-30">
                                <div class="mil-center">
                                    <h4 class="mil-upper mil-mb-20">Zaplecza biurowe<br/>i socjalne</h4>
                                    <div class="mil-divider-sm mil-mb-20"></div>
                                    <p class="mil-service-text">Integracja części biurowej i socjalnej z obiektem przemysłowym.</p>
                                </div>
                            </div>
                        </div>

                        </div>
                    </div>
        </section>
        <MilIllustrationSlider images={industrialPhotos} />;
        </div>
      </div>
    )
}